  <div class="main-wrapper">
  <div *ngIf="authenticatepage && page">
  <section aria-labelledby="pageHeadingSection" class="signup-section confirm-tab">
    <div *ngIf='initModal'>
      <app-modal [showModal]="initModal" [modalClass]="modalClass">
        <app-confirm-modal [modalPopupObject]='confirmModalPopup' [triggerElement]='eventEmit' (modalOutput)="closeModal($event)">
        </app-confirm-modal>
      </app-modal>
    </div>
    <div *ngIf="msg.id === 'success'" class="step-sub-heading step-confirmation">
      <div class="mobile-view-msg">
        <div class="symbol" [ngClass]="msg.id"><i [ngClass]="msg.class"></i></div>
        <div class="msg-container">
          <div><span>{{successHeading}} {{successMessage}}<span *ngIf="emmProductCode === 'DMPGZTP'"> Remember to accept Google<sup>®</sup> terms and conditions.</span></span></div>
        </div>
      </div>
      <div class="desktop-view-msg success-message">
          <div class="left">
            <!--<img src="assets/img/tick_green.png">-->
            <i class="icon-controls-approvalL" role="img" aria-hidden="true"></i>
          </div>
          <div>
            <h2>{{successHeading}}</h2>
          </div>
          <p>{{successMessage}}<span *ngIf="emmProductCode === 'DMPGZTP'"> Remember to accept Google<sup>®</sup> terms and conditions.</span></p>
        <!-- <span><h4>{{msg.header2}}</h4></span> -->
      </div>
    </div>
    <div *ngIf="msg.id === 'error'" class="alert valign-children-middle error-container">
      <div class="alert-error" role="img" aria-label="Alert.">
        <i class="icon-badgealert"></i>
      </div>
      <div>{{pageContent.systemErrorLabel}} <span class="message">{{msg.description}}</span></div>
    </div>

    <h2 id="pageHeadingSection" >{{pageContent.heading}}</h2>
    <p>
      <span><span class="label-review">{{pageContent.participantDate}} </span>: {{page.participationDate}}</span>
    </p>
    <div *ngIf="changeEnrollmentSettings" class="changeEnrollmentSettings">
        <div *ngFor="let page of pageDescription">
            <div *ngIf="!page.hide">
            <h3> {{page.header}} </h3>
    <div class="list-container" *ngIf="page.gridOptions">
        <div *ngIf="page.accordion" >
          <div *ngIf="page.moreThanFiveFan" class="accordion-grid">
          <app-accordion *ngIf="page.accordion" [accordion]="page.accordion" [accordionController]=false >
            <app-accordion-list *ngFor="let FAN of page.accordion" [option]="FAN" [isSubAccordion]=true >
              <app-customgrid [gridOptions]="page.gridOptions" (onDataChange)="page.gridCallback($event)">
              </app-customgrid>
            </app-accordion-list>
          </app-accordion>
        </div>
        <div *ngIf="!page.moreThanFiveFan">
        <app-customgrid [gridOptions]="page.gridOptions" (onDataChange)="page.gridCallback($event)">
          </app-customgrid>
          </div>
        </div>
        <!-- <div *ngIf="!page.accordion">
          <h4>{{page.gridHeader}}</h4>
          <app-customgrid [gridOptions]="page.gridOptions" (onDataChange)="page.gridCallback($event)">
          </app-customgrid>
        </div> -->
      </div>
      </div>
      </div>
    </div>
    <div  *ngIf="!changeEnrollmentSettings">
    <app-accordion *ngIf="page.fanList.accordion" [accordion]="page.fanList.accordion" [accordionController]=f alse>
      <app-accordion-list *ngFor="let FAN of page.fanList.accordion" [option]="FAN" [isSubAccordion]=true>
        <app-customgrid [gridOptions]="page.fanList.gridOptions">
        </app-customgrid>
      </app-accordion-list>
    </app-accordion>
    <div *ngIf="!page.fanList.accordion" class="fanlist-without-accordion">
      <p>{{fanList.length}} {{displayFANText}}</p>
      <app-customgrid [gridOptions]="page.fanList.gridOptions"></app-customgrid>
    </div>
  </div>
    <section aria-labelledby="mdmServiceHeadingSection" class="service-type" >
      <h3 id="mdmServiceHeadingSection">{{pageContent.MDMService.heading}}</h3>
      <p *ngIf="!prodFlag"><span class="label-review" [innerHTML]=pageContent.MDMService.mdmLabel ></span> <span [innerHTML]=pageContent.MDMService.ibmLabel></span></p>
      <p *ngIf="prodFlag"><span class="label-review">{{pageContent.MDMService.oemLabel}} </span>{{OemHeading}}</p>
      <p *ngIf="selectedGoogleID"><span class="label-review">{{pageContent.MDMService.googleIdLabel}} </span>{{selectedAccID}}</p>
      <p *ngIf="selectedSamsungID"><span class="label-review">{{pageContent.MDMService.samsungIdLabel}} </span>{{selectedAccID}}</p>
    </section>
    <div class="section-details settings-container">
      <h3>{{pageContent.settings.heading}}</h3>
      <div *ngIf="!prodFlag">
        <div *ngFor="let setting of page.settings; let i=odd;">
          <div [ngClass]="{'separator' : i}"><span class="label-review">{{setting.key}} </span>{{setting.value}}</div>
        </div>
      </div>
      <div *ngIf="prodFlag">
        <div *ngFor="let setting of page.settingsOem; let i=odd;">
          <div [ngClass]="{'separator' : i}"><span class="label-review">{{setting.key}} </span>{{setting.value}}</div>
        </div>
      </div>
    </div>
    <div *ngIf="!prodFlag" class="section-details application-container">
      <h3>{{pageContent.applications}}</h3>
      <ul>
        <li class="app-list" *ngFor="let app of page.applications">
          {{app}}
        </li>
      </ul>
    </div>
    <div class="section-details enrolldate-container">
      <h3>{{pageContent.enrollDate.heading}}</h3>
      <div *ngFor="let setting of page.enrollmentDate;">
        <div *ngIf="setting.key == 'New devices : '"><span class="label-review">{{setting.key}}</span> {{setting.value}}</div>
        <div *ngIf="!existingDateNull && setting.key == 'Existing devices : '"><span class="label-review">{{setting.key}}</span> {{setting.value}}</div>
        <div *ngIf="existingDateNull && setting.key == 'Existing devices : '"><span class="label-review">{{setting.key}}</span> Not set </div>
      </div>
    </div>
    <div class="message-box row" *ngIf="createProfile">
      <h3>{{page.formInput.heading}}</h3>
      <div [innerHtml]="page.formInput.description"></div>
      <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="profile-form" [ngClass]="{'error' : msg.id === 'error'}"><label for="profileName">{{pageContent.form.fieldLabel}}</label></div>
        <div class="col-md-7 profile-input">
          <div class="input-field">
            <input id="profileName" class="form-control" placeholder="Enter a profile name" type="text" maxlength="50" formControlName="customProfile"
              [ngClass]="{'error' : msg.id === 'error'}">
            <div *ngIf="msg.id === 'error'" class="error">{{pageContent.form.fieldErrMsg}}</div>
            <div *ngIf="msg.id === 'updated'" class="profile-success-msg">{{pageContent.form.fieldSuccMsg}}</div>
          </div>
          <div>
            <div class="tooltip-container input-tooltip">
              <i class="icon-flat-faq tooltip-icon" tabindex="0" aria-describedby="inputhelp" role="img" aria-label="What's this?"></i>
              <div role="tooltip" class="helper-text" id="inputhelp">
                <h5 *ngIf="pageContent.form.toolTipText.heading">{{pageContent.form.toolTipText.heading}}</h5>
                <p>{{pageContent.form.toolTipText.description}}</p>
              </div>
            </div>
          </div>
        </div>
        <button class="col-md-3 btn btn btn-secondary" type="submit" [disabled]="!form.valid" aria-label="Save.">{{pageContent.form.saveBtn}}</button>
      </form>
    </div>
    <div class="message-box row" *ngIf="(showAppleCertificate === 'Not Installed' || showAppleCertificate === 'Expired') && !prodFlag">
      <h3>{{pageContent.appleCertificate[showAppleCertificate].heading}}</h3>
      <div class="col-md-3"><img alt="" src="assets/img/marketplace-tab.png"></div>
      <div class="col-md-9 col-sm-12 apple-certificate-info">{{pageContent.appleCertificate[showAppleCertificate].description[0]}} <a routerLink="/appleCertificate">{{pageContent.appleCertificate[showAppleCertificate].description[1]}}</a>
        {{pageContent.appleCertificate[showAppleCertificate].description[2]}}</div>
        <div class="col-md-9 col-sm-12 apple-certificate-info mediaStop" *ngIf="supportArticle">
          <!-- <a href="javascript:void(0)"  (click)="getSupportContent(0)" >{{article.name}}</a> -->
          <att-gvp  [attr.video]="article.url" ></att-gvp>
        </div>
  </div>
  <div *ngIf="showOverviewModal">
      <app-modal [showModal]="showOverviewModal" [modalClass]="modalClass">
        <div class="model-cover terms">
          <div class="model-box">
            <div class="modal-header">
              <div class="corner-button">
                <button class="close" aria-label="Close" (click)="closeOverviewModal()">x</button>
              </div>
              <att-gvp [attr.video]="videoId"></att-gvp>
            </div>
          </div>
        </div>
      </app-modal>
      </div>
   <div class="row text-right cta-session">
      <button [routerLink]="backToCallingPage" href="javascript:void(0)" class="btn btn-secondary pull-right">{{pageContent.manageButton}}</button>
    </div>
  </section>
</div>
<app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>
  </div>
